var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.471 0.28843C11.769 0.281937 12.0617 0.367509 12.3084 0.53338C12.555 0.699251 12.7433 0.937223 12.8472 1.214C12.951 1.49077 12.9652 1.79267 12.8877 2.07779C12.8103 2.36292 12.6451 2.61695 12.415 2.80478L3.63812 10.2514L12.415 17.6955C12.5742 17.8113 12.7074 17.9583 12.8065 18.1275C12.9055 18.2967 12.9683 18.4844 12.9907 18.6787C13.0131 18.873 12.9948 19.0698 12.9369 19.2567C12.879 19.4437 12.7828 19.6169 12.6542 19.7653C12.5256 19.9138 12.3674 20.0341 12.1896 20.1192C12.0118 20.2043 11.8182 20.2521 11.6208 20.2597C11.4235 20.2672 11.2267 20.2344 11.0428 20.1631C10.8589 20.0919 10.6918 19.9838 10.5521 19.8456L0.503299 11.3307C0.345495 11.1973 0.218778 11.0318 0.131887 10.8452C0.0449958 10.6586 2.69282e-07 10.4556 2.69282e-07 10.2501C2.69282e-07 10.0447 0.0449958 9.8416 0.131887 9.65503C0.218778 9.46846 0.345495 9.30276 0.503299 9.16939L10.5521 0.64627C10.8059 0.422967 11.1315 0.296013 11.471 0.288102V0.28843Z",
    fill: "#01314A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackicon);
export default __webpack_public_path__ + "static/media/backicon.48edcb3d6eb2307ecea422b1c764ce53.svg";
export { ForwardRef as ReactComponent };